export function roundNumber(num, scale) {
	if (!('' + num).includes('e')) {
		return +(Math.round(num + 'e+' + scale) + 'e-' + scale);
	} else {
		const arr = ('' + num).split('e');
		let sig = ''
		if (+arr[1] + scale > 0) {
			sig = '+';
		}
		return +(Math.round(+arr[0] + 'e' + sig + (+arr[1] + scale)) + 'e-' + scale);
	}
}

export function spaceAndRoundNumber(amount) {
	const [intPart, decPart] = amount.toFixed(2).split('.');
	return intPart.length > 3
			? `${intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}${decPart === '00' ? '' : '.' + decPart}`
			: amount.toFixed(2);
}

export function spaceNumber(amount) {
	const [intPart] = amount.toFixed(2).split('.');
	return intPart.length > 3 ? intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : amount;
}

export function randomIntFromInterval(min, max) { // min and max included
	return Math.floor(Math.random() * (max - min + 1) + min);
}
